import { jsx as _jsx } from "react/jsx-runtime";
import { logAssert } from "@faire/web--source/common/logging";
import React, { createContext, useContext } from "react";
import { useCategoryPageRequestParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageRequestParams";
export var CategoryPageRequestParamsProvider = function(param) {
    var pageNumber = param.pageNumber, children = param.children;
    var requestParams = useCategoryPageRequestParams(pageNumber);
    return /*#__PURE__*/ _jsx(CategoryPageRequestParamsContext.Provider, {
        value: requestParams,
        children: children
    });
};
var CategoryPageRequestParamsContext = /*#__PURE__*/ createContext(undefined);
export var useCategoryPageRequestParamsContext = function() {
    var data = useContext(CategoryPageRequestParamsContext);
    logAssert(!!data, "Category page request params are undefined");
    return data;
};
